import { useState } from 'react'

import { Type } from '../../models/Type'
import Button from '../app/design/Button'
import Modal from '../app/design/Modal'
import { TextArea } from '../common/fields/TextArea'
import { TextField } from '../common/fields/TextField'
import { WorkflowPage } from '../workflows/WorkflowPage'

type Props = {
    isOpen: boolean
    onClose: () => void
    form: Type
    onDone: (updatedForm: Type) => void
    onMoreDetails?: () => void
    title?: string
}

export const RecordLiteModal = ({
    isOpen,
    onClose,
    form,
    onDone,
    onMoreDetails,
    title,
}: Props) => {
    const [name, setName] = useState(form.name ?? '')
    const [memo, setMemo] = useState(form.memo ?? '')

    const handleDone = () => {
        onDone(
            form.clone({
                name,
                memo,
            })
        )
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            footer={
                <div className="flex items-center justify-end gap-x-4">
                    {onMoreDetails !== undefined && (
                        <Button intent="secondary" onClick={onMoreDetails}>
                            Show more details
                        </Button>
                    )}
                    <Button onClick={handleDone} intent="primary">
                        Save
                    </Button>
                </div>
            }
            width={744}
        >
            <div className="flex flex-col items-stretch justify-start gap-y-8">
                <WorkflowPage.IconSection title="Name (required)" icon="field.large">
                    <TextField
                        size="medium"
                        placeholder="Enter name"
                        value={name ?? ''}
                        onChange={(event) => setName(event.target.value)}
                        onClear={() => setName('')}
                    />
                </WorkflowPage.IconSection>

                <WorkflowPage.IconSection title="Memo" icon="note.large">
                    <TextArea
                        size="medium"
                        placeholder="Enter memo"
                        value={memo ?? ''}
                        onChange={(event) => setMemo(event.target.value)}
                        onClear={() => setMemo('')}
                        isAutoResizing
                    />
                </WorkflowPage.IconSection>
            </div>
        </Modal>
    )
}
